import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard, Loader2, Wallet } from "lucide-react";
import { API } from "../../../config";
import { formatEur } from "../../../pages/SmsCreditPage";
import { daysLeftLabel } from "../SmsCreditWidget";

export const SmsTopupCard = ({ summary }) => {
  const [busy, setBusy] = useState(null);

  const buy = async (id) => {
    setBusy(id);
    try {
      const r = await axios.post(`${API}/admin/sms-credit/checkout-session`, {
        package_id: id, origin_url: window.location.origin,
      });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossibile avviare il pagamento");
      setBusy(null);
    }
  };

  return (
    <div className="bg-[#111] border border-gray-800 rounded-2xl p-6 h-full" data-testid="sms-topup-card">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
        <div className="flex items-center gap-3">
          <Wallet className="text-lojack-red" size={24} />
          <div>
            <p className="text-xs uppercase tracking-wider text-gray-400">Saldo disponibile</p>
            <p className={`text-4xl font-bold ${summary.balance_eur <= 0 ? "text-red-400" : "text-white"}`} data-testid="sms-credit-balance">
              {formatEur(summary.balance_eur)}
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-300" data-testid="sms-credit-estimate">
            ≈ {Number(summary.sms_it_left).toLocaleString("it-IT")} SMS verso numeri italiani
          </p>
          <p className={`text-xs ${summary.running_out ? "text-amber-300" : "text-gray-400"}`} data-testid="sms-credit-days-left">
            {daysLeftLabel(summary.days_left)}
            {summary.avg_daily_eur > 0 && ` · consumo medio ${formatEur(summary.avg_daily_eur)}/giorno`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 mb-3">
        <p className="text-sm text-gray-300">Ricarica con carta (accredito immediato)</p>
        {summary.topup_enabled && summary.stripe_mode === "test" && (
          <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-amber-500/20 text-amber-300" data-testid="sms-topup-test-badge">MODALITÀ TEST</span>
        )}
      </div>
      {!summary.topup_enabled && (
        <div className="mb-3 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-100" data-testid="sms-topup-disabled-notice">
          Pagamento con carta in fase di attivazione. Per ricaricare nel frattempo contatta TelcaVoIP: il credito verrà accreditato manualmente.
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {summary.packages.map((p) => (
          <button key={p.id} onClick={() => buy(p.id)} disabled={!!busy || !summary.topup_enabled}
            className="rounded-xl border border-gray-700 bg-black/40 p-4 text-left transition-colors hover:border-[#E31837] disabled:opacity-60"
            data-testid={`sms-topup-${p.id}`}>
            <p className="text-xl font-bold text-white">{formatEur(p.net_eur, 0)}</p>
            <p className="text-[11px] text-gray-400">+ spese gestione 2% {formatEur(p.fee_eur)}</p>
            <p className="text-xs text-gray-300 mt-1">Totale {formatEur(p.gross_eur)}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs text-lojack-red">
              {busy === p.id ? <Loader2 size={12} className="animate-spin" /> : <CreditCard size={12} />} Ricarica
            </span>
          </button>
        ))}
      </div>
      <p className="text-[11px] text-gray-500 mt-4">
        Il credito accreditato corrisponde al taglio scelto; al pagamento si aggiungono le spese di gestione ricarica del 2%. IVA non addebitata con il pagamento: fattura emessa da TelcaVoIP secondo il regime applicabile. A credito esaurito gli SMS ai clienti vengono sospesi e si usa solo l'email; i codici di accesso dei concessionari non vengono mai bloccati.
      </p>
    </div>
  );
};
